import type { FC } from 'react';

import CrehanaForBusiness from '@crehana/icons/logos/CrehanaForBusiness';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Container, colors } from '@crehana/ui';

import BreadCrumb from './components/BreadCrumb';

interface HeaderProps {
  step: number;
  logoOrg?: string;
  nameOrg?: string;
}

const { primaryMain, black } = colors;

const HeaderOnboarding: FC<HeaderProps> = ({ step, logoOrg, nameOrg }) => {
  return (
    <header className="pt-40 pb-32">
      <Container className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 md:tw-grid-cols-3 lg:tw-grid-cols-3">
        <BreadCrumb currentStep={step} />
        <section className="flex justify-center order-1">
          {logoOrg ? (
            <img className="h-40" alt={nameOrg} src={logoOrg} />
          ) : (
            <CrehanaForBusiness
              className="flex justify-center order-1"
              color={primaryMain}
              secondaryColor={black}
              size={36}
            />
          )}
        </section>
      </Container>
    </header>
  );
};
export default HeaderOnboarding;
